import { render } from "./AboutView.vue?vue&type=template&id=03c864c9&scoped=true"
import script from "./AboutView.vue?vue&type=script&lang=js"
export * from "./AboutView.vue?vue&type=script&lang=js"

import "./AboutView.vue?vue&type=style&index=0&id=03c864c9&scoped=true&lang=css"

import exportComponent from "/home/runner/work/adoranwodo2.0/adoranwodo2.0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-03c864c9"]])

export default __exports__